import {BreakoutroomModel} from 'models/program/BreakoutroomModel'
import React from 'react'
import {style} from 'util/style'
import {PopupModal} from 'views/layout/popupmodal'
import {ProgramPopupHeader, ProgramPopupText} from '../programpopup'

const styles = style('breakoutpopup')

export const BreakoutPopup: React.FC<{
	room: BreakoutroomModel
}> = ({room}) => {
	const {title} = room.data

	return (
		<div className={styles()}>
			<PopupModal.Content>
				<ProgramPopupHeader title={title} />
				<ProgramPopupText text="Lorem ipsum dolor sit amet" />
			</PopupModal.Content>
		</div>
	)
}
